module.exports = __webpack_public_path__ + "static/img/Inspection33.092ba918.png";